import BackBannerImage1 from "../assets/images/background-banner-1.png";
import BackBannerImage2 from "../assets/images/background-banner-2.png";
import BackBannerImage3 from "../assets/images/background-banner-3.png";

export const BackBannerImagesArray = [
  {
    id: 2,
    path: BackBannerImage2,
  },
  { id: 3, path: BackBannerImage3 },
  {
    id: 1,
    path: BackBannerImage1,
  },
];

/* import back1 from "../assets/images/back-bg-1.jpg";
import back2 from "../assets/images/back-bg-2.jpg";
import back3 from "../assets/images/back-bg-3.jpg";
import back4 from "../assets/images/back-bg-4.jpg";
import back5 from "../assets/images/back-bg-5.jpg";
import back7 from "../assets/images/back-bg-7.jpg";

export const backImgArray = [back1, back2, back3, back4, back5, back7];
 */
